export enum UserRole {
  Admin = "Admin",
  Grid = "Grid",
  ChatDisabled = "ChatDisabled",
  UploadPDFDisabled = "UploadPDFDisabled",
  ModelSettings = "ModelSettings",
  EventLongPolling = "EventLongPolling",
  McpToolsEnabled = "McpToolsEnabled",
}
